export class WebhookV1StandardPayloadRestoreJobRejected {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadRestoreJobRejectedTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadRestoreJobRejectedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadRestoreJobRejected.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadRestoreJobRejectedTypeEnum;
(function (WebhookV1StandardPayloadRestoreJobRejectedTypeEnum) {
    WebhookV1StandardPayloadRestoreJobRejectedTypeEnum["RestoreJobRejected"] = "RESTORE_JOB_REJECTED";
})(WebhookV1StandardPayloadRestoreJobRejectedTypeEnum || (WebhookV1StandardPayloadRestoreJobRejectedTypeEnum = {}));
